import { render, staticRenderFns } from "./TransactionLimits.vue?vue&type=template&id=62e31ff9&scoped=true"
import script from "./TransactionLimits.vue?vue&type=script&lang=js"
export * from "./TransactionLimits.vue?vue&type=script&lang=js"
import style0 from "./TransactionLimits.vue?vue&type=style&index=0&id=62e31ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e31ff9",
  null
  
)

export default component.exports